export default __webpack_public_path__ + "static/media/page-title-services.31abfdf7.svg";